var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{style:("\n    text-align:"+_vm.position+";\n    font-size: "+(_vm.window.width<480? "12px": "16px")+";\n    font-weight: lighter;\n    color:"+_vm.color)},[_vm._v("\n  "+_vm._s(_vm.sondageName)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dcb5302","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resultats/components/Title.vue
// module id = null
// module chunks = 